import IconButton from '@components/IconButton';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ControlIcon from '@icons/Control';
import { useFlow } from '@stackflow/react';
import { useAtomValue } from 'jotai';

import { itemFilterAtom } from '../../../atoms/itemFilterAtoms';

function ItemFilters() {
    const { push } = useFlow();
    const filters = useAtomValue(itemFilterAtom);
    return (
        <Container>
            <IconButton dot={filters.length > 0}
                onClick={() => push('ItemFilterBottomSheet', {})}>
                <ControlIcon color={colors.gray7} size={24}/>
            </IconButton>
        </Container>
    );
}

const Container = styled.div`
    flex-shrink: 0;
`;

export default ItemFilters;
